import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useLanguage } from "@/contexts/LanguageContext";
import { useTourGuide } from "./TourGuideProvider";
import { TourResumeChip } from "./TourResumeBanner";
import { cn } from "@/lib/utils";

/**
 * Tour Guide trigger button — lives in the TopBar next to Account Selector.
 * Shows a subtle red dot when there's contextual help available.
 * A compact "Resume tour" chip appears directly underneath when the tour
 * is paused mid-way.
 */
export const TourGuideButton = () => {
  const { language } = useLanguage();
  const { toggle, isOpen, isReady, isCompleted, currentStep } = useTourGuide();
  const fa = language === "fa";

  if (!isReady) return null;

  // Show "new" dot when the user hasn't completed the tour and it's currently closed
  const showDot = !isCompleted && !isOpen && currentStep?.id !== "tour_completed";

  return (
    <div className="relative flex flex-col items-stretch gap-1.5 w-[140px]">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={toggle}
            variant={isOpen ? "default" : "outline"}
            size="sm"
            className={cn(
              "relative h-9 w-full gap-2 px-3 transition-all",
              isOpen && "shadow-md"
            )}
            aria-label={fa ? "راهنمای تور" : "Tour Guide"}
          >
            <Compass className={cn("h-4 w-4", isOpen && "animate-pulse")} />
            <span className="text-xs font-medium leading-none">
              {fa ? "راهنما" : "Guide"}
            </span>
            {showDot && (
              <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-card animate-pulse" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          {fa
            ? isOpen
              ? "بستن راهنما"
              : "باز کردن راهنمای تور"
            : isOpen
              ? "Close guide"
              : "Open tour guide"}
        </TooltipContent>
      </Tooltip>
      <TourResumeChip />
    </div>
  );
};

